
import { ChangeDetectorRef, Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { SharedService } from '../shared.service';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { EncryptionService } from '../../services/encryption.service';
import { NgClass, UpperCasePipe } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-sidebar',
  imports: [NgClass, UpperCasePipe, RouterLink],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  @Output() isCollaseped = new EventEmitter<boolean>(false);
  isCollasepedflag: boolean = false;
  title = 'vas-project';
  isExpanded: boolean = false;   // For expanded layout
  isMobile: boolean = false;
  isMobileView: boolean = false;
  isvasSidebar: boolean = false;
  isCollapse: boolean = false;
  Userrole: any = this.encryptionService.getFromLocalStorage('user_type');
  subuserType = this.encryptionService.getFromLocalStorage('position_type');
  // src/app/components/dealer/order/order-sidebarmenu/order-sidebarmenu.component.ts
  MENUITEMS: any[] = [
    // {
    //   path: '/dealer/dashboard',
    //   title: 'Dashboard',
    //   icon: 'ti-smart-home',
    //   imgpath: '/assets/img/Vector.svg',
    //   type: 'link',
    //   active: false,
    //   User: '',
    // },
    {
      title: 'Pipeline',
      icon: 'ti-layout-sidebar',
      type: 'sub',
      imgpath: '/assets/img/Pipeline.svg',
      active: false,
      User: 'both',
      isOpen: true,
      children: [
        { path: '/dealer/pipeline/A0', title: 'A0-Enquiry', type: 'link', active: false, },
        { path: '/dealer/pipeline/A1', title: 'A1-Pre-Order', type: 'link', active: false, },
        { path: '/dealer/pipeline/A2', title: 'A2-KYC Verification', type: 'link', active: false, },
        { path: '/dealer/pipeline/A3', title: 'A3-Payments', type: 'link', active: false, },
        { path: '/dealer/pipeline/A4', title: 'A4-CIF Acceptance', type: 'link', active: false, },
        // { path: '/dealer/pipeline/emi', title: 'EMI-Activity', type: 'link',active: false, },
        { path: '/dealer/pipeline/cancel', title: 'Cancelled Order', type: 'link', active: false, },
        { path: '/dealer/pipeline/lost', title: 'Lost Opty', type: 'link', active: false, },
      ],
    },
    {
      path: '/dealer/pipeline-reports',
      title: 'Report',
      icon: 'ti-smart-home',
      imgpath: '/assets/img/Vector.svg',
      type: 'link',
      active: false,
      User: '',
    },
    {
      path: '/dealer/vas-history',
      title: 'Contracts History',
      icon: 'ti-smart-home',
      imgpath: '/assets/img/Vector.svg',
      type: 'link',
      active: false,
      User: '',
    },
    // {
    //   path: '/dealer/faq',
    //   icon: 'ti-file-description',
    //   title: 'FAQ',
    //   imgpath: '/assets/img/Help.svg',
    //   type: 'link',
    //   active: false
    // },
  ]

  VASOrderCreateMenu: any = [
    {
      title: 'Contract Details',
      subtitle: 'Select Plan.',
      icon: 'ti-smart-home',
      type: 'sub',
      active: false,
      User: 'both',
    },
    {
      title: 'Customer Details',
      subtitle: 'Enter the customer information.',
      icon: 'ti-smart-home',
      type: 'sub',
      active: false,
      User: 'both',
    },
    {
      title: 'Payment Details',
      subtitle: 'Select your payment information.',
      icon: 'ti-smart-home',
      type: 'sub',
      active: false,
      User: 'both',
    },
    {
      title: 'CIF Details',
      subtitle: 'Select your payment information.',
      icon: 'ti-smart-home',
      type: 'sub',
      active: false,
      User: 'both',
    },
    // CIF Details

  ]
  // For mobile view case
  constructor(private sharedService: SharedService, private router: Router, private cdr: ChangeDetectorRef,
    private encryptionService: EncryptionService
  ) { }

  username: string | null = '';
  userType: string | null = '';
  ngOnInit() {
    this.username = this.encryptionService.getFromLocalStorage('username');
    this.userType = this.encryptionService.getFromLocalStorage('user_type');
    this.isCollapse = JSON.parse(localStorage.getItem('isCollasepedflag') || 'false');
    this.sharedService.toggleSidebar$.subscribe((value: boolean) => {
      this.isCollapse = value;
    });
    //     localStorage.setItem('isCollasepedflag', JSON.stringify(this.isCollasepedflag));

    // Detect mobile view on page load
    this.detectMobileView(false);
    const matchUrl = "/dealer/order";
    this.getOrdermatchUrl(matchUrl, this.router.url)
    if (this.router.url.includes(matchUrl)) {
      // console.log(this.router.url,'this.router.url1')
      this.isvasSidebar = true;
    } else {
      this.isvasSidebar = false;
    }
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        //console.log('URL changed: ', event.url);
        this.getOrdermatchUrl(matchUrl, this.router.url)
      }
    });
    this.setActivePath(this.router.url);
    // Optionally listen for window resize events
    window.addEventListener('resize', () => {
      this.detectMobileView(false);
    });
    this.getIsorderOpen(matchUrl, this.router.url);
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
        this.setActivePath(this.router.url);
      }
      if (event instanceof NavigationEnd) {
        this.setActivePath(this.router.url);
      }
    });
  }
  ngDocheck() {
    this.detectMobileView(false);
    // Optionally listen for window resize events
    window.addEventListener('resize', () => {
      this.detectMobileView(false);
    });
  }
  setActivePath(pathToActivate: string) {
    //console.log(pathToActivate,"pathToActivatepathToActivate")
    this.MENUITEMS.forEach((item: any) => {
      let parentActive = false;  // Keep track of whether the parent should be active

      // Check if the item has children
      if (item?.children) {
        item.children.forEach((child: any) => {
          if (child.path === pathToActivate) {
            child.active = true;  // Set child active
            parentActive = true;  // Mark the parent as active
          } else {
            child.active = false; // Deactivate other children
          }
        });
      }

      // Set parent active if a matching child was found
      if (parentActive) {
        item.active = true;
      } else if (item.path === pathToActivate) {
        item.active = true;  // If it's a direct match, activate the parent
      } else {
        item.active = false; // Deactivate other parents
      }
    });
    //console.log(this.MENUITEMS)
  }
  // You can detect mobile view using screen size
  detectMobileView(val: boolean) {
    // alert("okay")
    this.isMobile = val;
    this.isMobileView = window.innerWidth <= 768;
    this.sharedService.toggleClass(val);
  }
  getActivemenu(item: any): any {
    item.isOpen = !item.isOpen;
  }
  // Method to navigate to the pipeline route
  navigateTo(path: string, parent: any, child: any, event: Event): void {
    //console.log('path - ',path);
    //console.log(parent,'parent');
    //console.log(child,'child');

    this.MENUITEMS?.forEach(menuItem => {
      menuItem.active = false
      if (menuItem?.children) {
        menuItem.children.forEach((childItem: any) => childItem.active = false);
      }
    });
    // Prevent parent click event from firing
    event.stopPropagation();
    // Reset all child items of the clicked parent
    parent?.children?.forEach((childItem: any) => childItem.active = false);
    // Set the clicked child item to active
    child.active = true;
    // Ensure the parent is also set to active
    parent.active = true;
    if (child.length == 0) {

    } else {

    }

    this.router.navigate([path]);
  }
  getActiveChild(parent: any, child: any, event: Event) {
    //console.log(parent,'parent')
    //console.log(child,'child')

    this.MENUITEMS?.forEach(menuItem => {
      menuItem.active = false
      if (menuItem?.children) {
        menuItem.children.forEach((childItem: any) => childItem.active = false);
      }
    });
    // Prevent parent click event from firing
    event.stopPropagation();
    // Reset all child items of the clicked parent
    parent?.children?.forEach((childItem: any) => childItem.active = false);
    // Set the clicked child item to active
    child.active = true;
    // Ensure the parent is also set to active
    parent.active = true;
    if (child.length == 0) {

    } else {

    }

  }
  getIsorderOpen(matchUrl: any, mainUrl: any): any {
    this.sharedService.toggleVasCreateOrder$.subscribe((value: boolean) => {
      if (mainUrl.includes(matchUrl)) {
        this.isvasSidebar = true;
      } else {
        this.isvasSidebar = value;
      }
    });
  }
  getOrdermatchUrl(matchUrl: any, mainUrl: any): any {
    if (mainUrl.includes(matchUrl)) {
      this.isvasSidebar = true;
    } else {
      this.isvasSidebar = false;
    }
    this.cdr.detectChanges();
  }
}
